enum KiosksLiveUsageActionEnum {
  SET_KIOSK_LIVE_USAGE = 'SET_KIOSK_LIVE_USAGE',
  LOAD_KIOSK_LIVE_USAGE_DATA = 'LOAD_KIOSK_LIVE_USAGE_DATA',
  LOAD_KIOSK_LIVE_USAGE_RESERVATION_UPDATED_DATA = 'LOAD_KIOSK_LIVE_USAGE_RESERVATION_UPDATED_DATA',
}

export default KiosksLiveUsageActionEnum;
